import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlbumsService, Album } from '../../../services/albums.service';
import { FaPlus, FaTrash, FaImages } from 'react-icons/fa';

const AlbumListPage: React.FC = () => {
    const [albums, setAlbums] = useState<Album[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadAlbums();
    }, []);

    const loadAlbums = async () => {
        try {
            const response = await AlbumsService.findAll(1, 100); // Load all for now
            setAlbums(response.data);
        } catch (error) {
            console.error('Failed to load albums', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id: string) => {
        if (window.confirm('Etes-vous sûr de vouloir supprimer cet album ?')) {
            try {
                await AlbumsService.delete(id);
                loadAlbums();
            } catch (error) {
                console.error('Failed to delete album', error);
            }
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold">Gestion des Albums</h1>
                <Link
                    to="/admin/albums/create"
                    className="bg-primary text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-primary-dark transition-colors"
                >
                    <FaPlus /> Nouvel Album
                </Link>
            </div>

            {loading ? (
                <div className="text-center py-8">Chargement...</div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {albums.map((album) => (
                        <div key={album.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                            <div className="h-48 bg-gray-200 relative">
                                {album.images.length > 0 ? (
                                    <img
                                        src={album.images[0].thumb_url}
                                        alt={album.title}
                                        className="w-full h-full object-cover"
                                    />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-400">
                                        <FaImages size={48} />
                                    </div>
                                )}
                                <div className="absolute top-2 right-2 bg-black bg-opacity-50 text-white px-2 py-1 rounded text-sm">
                                    {album.images.length} photos
                                </div>
                            </div>
                            <div className="p-4">
                                <h3 className="font-bold text-lg mb-2">{album.title}</h3>
                                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                                    {album.description || 'Aucune description'}
                                </p>
                                <div className="flex justify-between items-center">
                                    <Link
                                        to={`/admin/albums/${album.id}/upload`}
                                        className="text-primary hover:text-primary-dark font-medium"
                                    >
                                        Gérer les photos
                                    </Link>
                                    <button
                                        onClick={() => handleDelete(album.id)}
                                        className="text-red-500 hover:text-red-700"
                                    >
                                        <FaTrash />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AlbumListPage;
